import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration
// Replace these values with your Azure AD app registration details
export const msalConfig: Configuration = {
  auth: {
    clientId: '86547372-e52b-47ed-98e6-cf05426c8f91', // Application (client) ID from Azure portal
    authority: 'https://login.microsoftonline.com/40a9a30f-4b1b-4a52-affb-f1c3620fa409', // Tenant-specific endpoint
    redirectUri: window.location.origin, // Must match redirect URI in Azure portal
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes required for the application
export const loginRequest: PopupRequest = {
  scopes: [
    'User.ReadBasic.All',    // Required for directory search
    'Calendars.ReadBasic',    // Required for free/busy information
  ],
};

// Additional scopes for silent token acquisition
export const tokenRequest = {
  scopes: ['User.ReadBasic.All', 'Calendars.ReadBasic'],
};
